export const WOJEWODZTWA = [
	{ code: 'LUB', name: 'Lubelskie' },
	{ code: 'PDK', name: 'Podkarpackie' },
	{ code: 'ŚW', name: 'Świętokrzyskie' },
	{ code: 'MŁP', name: 'Małopolskie' },
	{ code: 'ŚL', name: 'Śląskie' },
	{ code: 'ŁDZ', name: 'Łódzkie' },
	{ code: 'DLN', name: 'Dolnośląskie' },
	{ code: 'WLKP', name: 'Wielkopolskie' },
	{ code: 'KUJ', name: 'Kujawsko-pomorskie' },
	{ code: 'ZPOM', name: 'Zachodniopomorskie' },
	{ code: 'POM', name: 'Pomorskie' },
	{ code: 'MAZ', name: 'Mazowieckie' },
	{ code: 'PODL', name: 'Podlaskie' },
	{ code: 'WARM', name: 'Warmińsko-mazurskie' },
	{ code: 'OPL', name: 'Opolskie' },
	{ code: 'LBS', name: 'Lubuskie' },
]

const fold = value => `${value ?? ''}`
	.toLowerCase()
	.replace(/ł/g, 'l')
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '')
	.replace(/wojewodztwo/g, '')
	.replace(/voivodeship/g, '')
	.replace(/[^a-z]/g, '')

const byFoldedCode = new Map(WOJEWODZTWA.map(item => [fold(item.code), item.code]))
const byFoldedName = new Map(WOJEWODZTWA.map(item => [fold(item.name), item.code]))

export function resolveWojewodztwoCode(value) {
	const folded = fold(value)
	if (!folded) return ''
	return byFoldedCode.get(folded) || byFoldedName.get(folded) || ''
}
